<div class="dashboard-heading">
  <h1>{{ 'ADMIN_PANEL_SERVICES_MASTER_CATEGORIES' | translate }}</h1>

  <div>
    <dx-button text="{{ 'SYNC_CATALOG' | translate }}" icon="mdi mdi-sync" class="btn btn-green" (onClick)="this.sync()"></dx-button>
  </div>
</div>

<dx-data-grid
  [dataSource]="this.masterCategories"
  [showBorders]="true"
  [allowColumnResizing]="true"
  [columnMinWidth]="70"
  [columnAutoWidth]="true"
  class="datagrid-admin mb-5">
  <!--<dxo-group-panel [visible]="true"></dxo-group-panel>-->

  <!--<dxo-grouping [autoExpandAll]="true"></dxo-grouping>-->

  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column
    dataField="code"
    caption="{{ 'SERVICES_MASTER_CATEGORIES_ID' | translate }}"
    cssClass="text-start ps-3 border-right"></dxi-column>
  <dxi-column
    [dataField]="this.isLanguageUa ? 'nameUa' : 'nameRu'"
    caption="{{ 'SERVICES_MASTER_CATEGORIES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>
  <dxi-column dataField="priority" caption="{{ 'PRIORITY' | translate }}" cssClass="text-center border-right"></dxi-column>

  <dxi-column name="changePriority" type="buttons" caption="{{ 'CHANGE_PRIORITY' | translate }}" cssClass="cell-center border-right">
    <dxi-button template="changePriorityTemplate">
      <div *dxTemplate="let $event of 'changePriorityTemplate'">
        <dx-button icon="mdi mdi-arrow-up-bold" class="btn-icon color-green" (onClick)="this.upPriority($event)"></dx-button>
        <dx-button icon="mdi mdi-arrow-down-bold" class="btn-icon color-red" (onClick)="this.downPriority($event)"></dx-button>
      </div>
    </dxi-button>
  </dxi-column>

  <dxi-column caption="{{ 'ICON' | translate }}" cellTemplate="iconTemplate" cssClass="cell-center border-right">
    <div *dxTemplate="let $event of 'iconTemplate'" class="icon text-center">
      @if ($event.data.iconBody) {
        <img [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + $event.data.iconType + ';base64,' + $event.data.iconBody)" />
      }
    </div>
  </dxi-column>

  <dxi-column name="iconUpload" type="buttons" caption="{{ 'ICON_UPLOAD' | translate }}" cssClass="cell-center border-right">
    <dxi-button template="uploadIconTemplate">
      <div *dxTemplate="let $event of 'uploadIconTemplate'">
        <dx-button icon="mdi mdi-upload" class="btn-icon color-green" (onClick)="this.uploadIcon($event)"></dx-button>
      </div>
    </dxi-button>
  </dxi-column>

  <dxi-column name="iconDelete" type="buttons" caption="{{ 'ICON_DELETE' | translate }}">
    <dxi-button template="deleteIconTemplate">
      <div *dxTemplate="let $event of 'deleteIconTemplate'">
        <dx-button icon="mdi mdi-close-circle" class="btn-icon color-red" (onClick)="this.deleteIcon($event)"></dx-button>
      </div>
    </dxi-button>
  </dxi-column>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100, 1000]"></dxo-pager>
</dx-data-grid>

<dialog-edit-icon></dialog-edit-icon>
